export default function isIpePlatform() {
  if (process.env.PLATFORM === 'ipe') {
    return true;
  }

  return (
    window.location.hostname.endsWith('ipe.courseware.bj33smarter.com') ||
    window.location.hostname.endsWith('ipe.courseware.staging.bj33smarter.com')
  );
}
